<template>
  <div>
    <b-card no-body class="mt-3" type="dark" bg-variant="light">
      <b-col class="ml--2">
        <h3 class="mt-1 ml-1">Ergebnis</h3>
      </b-col>
    </b-card>
    <ErgebnisCard />
  </div>
</template>

<script>
import ErgebnisCard from "@/components/ErgebnisCard.vue";
export default {
  name: "Ergebnisse",
  components: {
    ErgebnisCard
  }
};
</script>
